import React, { Component } from 'react';
import _ from 'lib/lodash'

import ACL from 'components/common/ACL'
import fileSize from 'filesize'
import FontIcon from 'react-md/lib/FontIcons/FontIcon';
import MenuButton from 'react-md/lib/Menus/MenuButton';
import Button from 'react-md/lib/Buttons'
import ListItem from 'react-md/lib/Lists/ListItem';
import Divider from 'react-md/lib/Dividers'

import TextFieldEdit from 'components/common/TextFieldEdit'

import LoadingSpinnerSmall from 'components/common/LoadingSpinnerSmall'
import VideoCardPlayer from './VideoCardPlayer'

import './VideoCardItem.css'

function getDurationString(duration) {
	if (!duration) return "";
	const dt = new Date(1000 * duration);
	const pos = dt.getUTCHours() > 0 ? [11, 8] : [14, 5];
	return dt.toISOString().substr(pos[0], pos[1]) + " • ";
}

class VideoCardItem extends Component {
	state = {
		isEditing: false,
	};

	handleMenuOpen = (e) => {
		const { video } = this.videoPlayer;

		if (video) video.play();
	};

	handleMenuEdit = () => this.setState({ ...this.state, isEditing: true });

	handleMenuEditExit = () => {
		const { actionHandler } = this.props;

		this.setState({...this.state, isEditing: false});
		actionHandler.addToast("Änderungen gespeichert");
	};

	handleMenuDelete = e => {
		const { node, actionHandler } = this.props;
		const { deleteNodeFromPayload, addToast } = actionHandler;

		deleteNodeFromPayload(node).then(() => addToast("Video gelöscht"));
	};

	handleActionNestedItems = (e) => {
		this.listItem._handleClick(e);
		this.setState({
			...this.state,
		});
	};

	updateProperty = (property) => {
		const { node, actionHandler } = this.props;
		const { changeNodeProperty } = actionHandler;

		changeNodeProperty(node, property);
	};

	render() {
		const { node, actionHandler, aclAllow } = this.props;
		const { nodeHandler } = actionHandler;
		const isDeleting = nodeHandler.isDeleting && nodeHandler.currentNode.$id === node.$id;
		const { properties } = node;
		const { isEditing } = this.state;

		const { title } = properties;

		const thumbnailUrl = _.get(node, 'storage.thumbnailPublicUrl');
		const fileUrl = _.get(node, 'storage.filePublicUrl');

		const subtitle = `${getDurationString(_.get(node, 'storage.metadata.duration'))}${fileSize(_.get(node, 'storage.totalSize'))}`;

		const menuItems = [
			<ACL allow={aclAllow.edit} key="admin">
				<ListItem
					primaryText="Löschen"
					leftIcon={<FontIcon>delete</FontIcon>}
					onClick={this.handleMenuDelete} />
			</ACL>
		];

		const renderMenu = () => (
			<ACL allow={aclAllow.edit}>
				<div className="card-button-container">
					{ !isEditing && <Button icon onClick={this.handleMenuEdit}>edit</Button> }
					<MenuButton
						key="menu"
						id={`vert-menu${node.$id}`}
						icon
						menuItems={menuItems}
						simplifiedMenu={false}
						anchor={{
							x: MenuButton.HorizontalAnchors.LEFT,
							y: MenuButton.VerticalAnchors.OVERLAP,
						}}
					>
						<FontIcon>more_vert</FontIcon>
					</MenuButton>
				</div>
			</ACL>
		);

		const renderTitle = () => (
			<div>
				{ isEditing &&
				<TextFieldEdit
					id="title-field-video"
					type="title"
					label="Titel"
					value={title}
					onSubmit={value => this.updateProperty({ title: value })}
					rightIcon={<FontIcon className="icon-done" onClick={this.handleMenuEditExit}>done</FontIcon>}
				/> }
				{ !isEditing && title && <span className="link" onClick={this.handleMenuOpen}>{title}</span> }
			</div>
		);

		const renderSubtitle = () => (
			<span className="link" onClick={this.handleMenuOpen}>{subtitle}</span>
		);

		const renderContent = () => (
			<div className="video-card-item" id={node.$id}>
				<VideoCardPlayer
					id={`node:${node.$id}:video:${title}`}
					ref={c => this.videoPlayer = c}
					src={fileUrl}
					poster={thumbnailUrl}
					//onLoadedMetadata={this.handleLoadedMetadata}
				/>
				<ListItem
					ref={c => this.listItem = c}
					primaryText={renderTitle()}
					secondaryText={renderSubtitle()}
					rightIcon={renderMenu()}
					disabled
				>
				</ListItem>
			</div>
		);

		const renderIsDeleting = () => <LoadingSpinnerSmall message="Video wird gelöscht..." />;

		return (
			<div className="video-card-item-container">
				{!isDeleting ? renderContent() : renderIsDeleting()}
				<Divider className="video-card-item-divider"/>
			</div>
		)
	}
}

export default VideoCardItem;


// WEBPACK FOOTER //
// ./src/components/cards/video/v1/VideoCardItem.jsx